import { createFileRoute } from "@tanstack/react-router";
import { EnvPreset } from "gfx/EnvPreset";
import { envPresetSceneLights } from "gfx/sceneLights";
import withCustomizer from "lib/state/withCustomizer";
import {
  addAnnotationTestTHREEGeometry,
  ANNOTATION_TEST_CAMERA_SETTINGS,
  ANNOTATION_TEST_KEYS,
} from "test/util/annotationTestUtil";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import withAuthentication from "../../components/withAuthentication";

function AnnotationPage() {
  const sceneLights = {
    ...envPresetSceneLights[EnvPreset.WHITEBOX],
    interiorAmbientLight: undefined, // disable the interior ambient light
  };

  const options = {
    gui: false,
    ssfxRenderer: true,
    animate: true,
    sceneLights,
    debugFeaturesEnabled: false,
    cameraSettings: ANNOTATION_TEST_CAMERA_SETTINGS,
    useMSAA: false,
  };

  return (
    <HeadlessRenderTestPage
      testName="Annotation render"
      options={options}
      testKeys={ANNOTATION_TEST_KEYS}
      addGeometry={addAnnotationTestTHREEGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/annotation")({
  component: withAuthentication(withCustomizer(AnnotationPage), { superAdmin: true }),
});
